const initState = {
  player: [],
  playerLastDocument: "",
  playerMoreData: true,
  singlePlayer: {},
  blocked: [],
  license: [],
  payments: [],
  singlePlayerLicense: [],
  chatEarning: [],
  chatLoading: false,
};

const playerReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ATHLETES":
      return {
        ...state,
        player: action.payload.data,
        playerLastDocument: action.payload.lastDocument,
        playerMoreData: action.payload.hasMoreDocument,
      };
    case "IS_PLAYER_BLOCK":
      let { block, id } = action.payload;
      let updatePlayer = state.player.map((items) =>
        items.id == id ? { ...items, blocked: block } : items
      );
      return {
        ...state,
        player: updatePlayer,
      };
    case "GET_ATHLETES_LOAD_MORE":
      return {
        ...state,
        player: [...state.player, ...action.payload.data],
        playerLastDocument: action.payload.lastDocument,
        playerMoreData: action.payload.hasMoreDocument,
      };
    case "GET_SIGNUP_PAYMENTS":
      return {
        ...state,
        payments: action.payload,
      };
    case "GET_SINGLE_PLAYER":
      return {
        ...state,
        singlePlayer: action.payload,
      };
    case "GET_BLOCKED_PLAYERS":
      return {
        ...state,
        blocked: action.payload,
      };
    case "GET_LICENSE":
      return {
        ...state,
        license: action.payload,
      };
    case "GET_CHAT_EARNING":
      return {
        ...state,
        chatEarning: action.payload,
      };
    case "CHAT_EARNING_LOADING":
      return {
        ...state,
        chatLoading: action.payload,
      };
    case "GET_SINGLE_PLAYER_LICENSE":
      return {
        ...state,
        singlePlayerLicense: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default playerReducer;
